import React from "react";

function ColoredCircle({ initials }) {
    let colorList = ['#ef5350', '#ec407a', '#ab47bc', '#7e57c2', '#5c6bc0', '#42a5f5', '#29b6f6', '#26c6da', '#26a69a', '#4caf50', '#ffc107', '#ff9800', '#ff5722', '#795548', '#607d8b']
    // const colorCode = '#' + Math.floor(Math.random() * 16777215).toString(16); // generate random color code
    const colorCode = colorList[Math.floor(Math.random() * colorList.length)];
    const style = {
        backgroundColor: colorCode,
        width: 45,
        height: 45,
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 18,
        fontWeight: '500',
        textTransform: 'uppercase',
        color: '#ffffff'
    };
    return (
        <div style={style}>
            {initials}
        </div >
    );
}

export default ColoredCircle;